import React from "react"

const RequiredIndicator = () => (
  <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
)

export const TextField = ({ id, text, placeholder, required }) => (
  <div className="field">
    <div className="label">
      <label htmlFor={id}>{text}{ required ? <RequiredIndicator/> : null }</label>
    </div>
    <div className="input">
      <input type="text" name={id} placeholder={placeholder} required={required} maxLength={64} />
    </div>
  </div>
)

export const NumberField = ({ id, text, placeholder, required }) => (
  <div className="field">
    <div className="label">
      <label htmlFor={id}>{text}{ required ? <RequiredIndicator/> : null }</label>
    </div>
    <div className="input">
      <input type="number" name={id} placeholder={placeholder} required={required} min={0} max={99} />
    </div>
  </div>
)

export const MailField = ({ id, text, required }) => (
  <div className="field">
    <div className="label">
      <label htmlFor={id}>{text}{ required ? <RequiredIndicator/> : null }</label>
    </div>
    <div className="input">
      <input type="email" name={id} required={required} maxLength={64} />
    </div>
  </div>
)

export const PhoneField = ({ id, text, required }) => (
  <div className="field">
    <div className="label">
      <label htmlFor={id}>{text}{ required ? <RequiredIndicator/> : null }</label>
    </div>
    <div className="input">
      <input type="tel" name={id} required={required} maxLength={64} />
    </div>
  </div>
)

export const SelectField = ({ id, text, required, options }) => (
  <div className="field">
    <div className="label">
      <label htmlFor={id}>{text}{ required ? <RequiredIndicator/> : null }</label>
    </div>
    <div className="input">
      <select name={id} required={required}>
        { options.map(i => <option key={i.value} value={i.value}>{i.text}</option>) }
      </select>
    </div>
  </div>
)

export const RadioField = ({ id, text, options, selected, required }) => (
  <div className="field">
    <div className="label">
      <label>{text}{ required ? <RequiredIndicator/> : null }</label>
    </div>
    <div className="input multiple">
      {
        options.map((i, index) => (
          <div key={i.value} className="multiple-input">
            <input type="radio" id={i.value} name={id} value={i.value} defaultChecked={selected === index} required={required} />
            <label htmlFor={i.value}>{i.text}</label>
          </div>
        ))
      }
    </div>
  </div>
)

export const CheckField = ({ id, text, options, selected, required }) => (
  <div className="field">
    <div className="label">
      <label>{text}{ required ? <RequiredIndicator/> : null }</label>
    </div>
    <div className="input multiple">
      {
        options.map((i, index) => (
          <div key={i.value} className="multiple-input">
            <input type="checkbox" id={i.value} name={id} value={i.value} defaultChecked={selected === index} required={required} />
            <label htmlFor={i.value}>{i.text}</label>
          </div>
        ))
      }
    </div>
  </div>
)

export const MessageField = ({ id, text, placeholder, required }) => (
  <div className="field">
    <div className="label">
      <label htmlFor={id}>{text}{ required ? <RequiredIndicator/> : null }</label>
    </div>
    <div className="input">
      <textarea name={id} required={required} placeholder={placeholder} maxLength={250} />
    </div>
  </div>
)

export const SatisfactionField = ({ id, text, selected, required }) => {
  const satisfactionOptions = [
    { text: '😠', value: 'Very dissatisfied' },
    { text: '🙁', value: 'Dissatisfied' },
    { text: '😐', value: 'Neutral' },
    { text: '🙂', value: 'Satisfied' },
    { text: '😀', value: 'Very satisfied' }
  ]

  return (
    <div className="field">
      <div className="label">
        <label>{text}{ required ? <RequiredIndicator/> : null }</label>
      </div>
      <div className="input multiple satisfaction">
        {
          satisfactionOptions.map((i, index) => (
            <div key={i.value} className="multiple-input">
              <input type="radio" id={i.value} name={id} value={i.value} defaultChecked={selected === index} required={required} />
              <label htmlFor={i.value}>{i.text}</label>
            </div>
          ))
        }
      </div>
    </div>
  )
}

export const HiddenField = ({ id, value }) => (
  <input type="hidden" name={id} value={value}/>
)

export const SubmitButton = ({ text, color, disabled }) => (
  <div className="submit">
    <div className="input">
      <input type="submit" value={text} className="button primary" disabled={disabled} style={{ backgroundColor: color }}/>
    </div>
  </div>
)